import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { IconSize } from './BaseIcon';

const BLOB_PATH =
  'M12 4.5C14.5 4.2 17 5.5 18.5 7.8C20 10 20 13 18.5 15.2C17 17.5 14.5 19 12 19.2C9.5 19.4 7 18 5.5 15.8C4 13.5 3.8 10.5 5.2 8C6.5 5.5 9.5 4.8 12 4.5Z';

const TRANSITION =
  'transform 0.45s cubic-bezier(0.22,1,0.36,1), opacity 0.45s cubic-bezier(0.22,1,0.36,1), stroke-width 0.45s cubic-bezier(0.22,1,0.36,1)';

const STYLES = `
  .studio-orb {
    transform-origin: center;
    transition: ${TRANSITION};
    opacity: 0.8;
    stroke-width: 1.5;
  }

  [data-studio-logo-hovered] .studio-orb,
  [data-sidebar="menu-button"]:hover .studio-orb,
  button:hover > .studio-logo-wrap .studio-orb {
    transform: scale(1.12);
    opacity: 1;
    stroke-width: 2;
  }
`;

export const StudioAssistantLogo: FC<IconProps & { hovered?: boolean }> = ({
  size = 'md',
  hovered,
  className,
}) => {
  const px = IconSize[size];

  return (
    <span
      className={className}
      data-studio-logo-hovered={hovered || undefined}
      style={{ display: 'contents' }}
    >
      <style>{STYLES}</style>
      <span className="studio-logo-wrap" style={{ display: 'contents' }}>
        <svg
          fill="none"
          height={px}
          style={{ overflow: 'visible', flexShrink: 0 }}
          viewBox="0 0 24 24"
          width={px}
        >
          <defs>
            <linearGradient id="orb-grad" x1="0%" x2="100%" y1="0%" y2="100%">
              <stop offset="0%">
                <animate
                  attributeName="stop-color"
                  dur="6s"
                  repeatCount="indefinite"
                  values="#a78bfa;#67e8f9;#f0abfc;#a78bfa"
                />
              </stop>
              <stop offset="50%">
                <animate
                  attributeName="stop-color"
                  dur="6s"
                  repeatCount="indefinite"
                  values="#67e8f9;#f0abfc;#a78bfa;#67e8f9"
                />
              </stop>
              <stop offset="100%">
                <animate
                  attributeName="stop-color"
                  dur="6s"
                  repeatCount="indefinite"
                  values="#f0abfc;#a78bfa;#67e8f9;#f0abfc"
                />
              </stop>
            </linearGradient>
          </defs>
          <path
            className="studio-orb"
            d={BLOB_PATH}
            fill="rgba(255,255,255,0.06)"
            stroke="url(#orb-grad)"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </span>
  );
};
